import React from 'react';
import './Footer.css';
import { Link } from "react-router-dom";

const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (
        <>
            <div className='footer'>
                <div className='footer__s1'>
                    <img src="/Images/logo.png" alt="Logo" />
                    <p>Boltcrew Engineering is a premier provider of integrated mechanical and electrical solutions, <br /> dedicated to enhancing industrial efficiency and operational reliability. Founded on the principles of <br /> precision and technical excellence, we support diverse industries through four core pillars: <br /> Retrofit Processes, Preventive Maintenance, Spare Part Management, and Advanced Electrical & Control Systems.</p>
                </div>
                <div className='footer__s2' style={{ display: "none" }}>
                    <h3>Certifications</h3>
                    <div className='footer__s2__sub'>
                        <img src="/Images/sample solutions.png" alt="Certification" />
                        <img src="/Images/sample solutions.png" alt="Certification" />
                    </div>
                </div>
                <div className='footer__s3'>
                    <div className='footer__s3__sub1'>
                        <h3>Follow Us</h3>
                        <div className='footer__s3__sub2__sub'>
                            <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
                                <img src="/Images/facebook.png" alt="Facebook" />
                            </a>

                            <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                                <img src="/Images/instagram.png" alt="Instagram" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className='footer__end'>
                <p>&copy; {currentYear} Boltcrew Engineering. All rights reserved. </p>
                <h3><Link to="/privacy-policy">Private Policy</Link></h3>
            </div>
        </>

    );
};

export default Footer;
